import ControlButton from 'pages/Home/admin/ControlButton/ControlButton'
import React from 'react'

export interface SeriesFilterAdminControlsProps {
  openAddSeriesDialog: ()=> void
}

export default function SeriesFilterAdminControls(props: SeriesFilterAdminControlsProps) {
  const { openAddSeriesDialog } = props

  return (
    <div>
      <ControlButton size="small" variant="add" onClick={openAddSeriesDialog} style={{ top: '0', left: '-24px' }} />
    </div>
  )
}
